import React from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import TeachersOnboarding from "./onboarding/TeachersOnboarding";
import TeachersPrincipal from "./principal/TeachersPrincipal";

const Classes = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_onboarding) {
      return <TeachersOnboarding />;
    }
    if (state.auth.user.is_principal) {
      return <TeachersPrincipal />;
    }
    return <PermissionDenied />;
  }
};

export default Classes;
